import type { PlatformApp } from '@/types/platform'

export interface AppCardTheme {
  readonly accentHex: string
  readonly glowColor: string
  readonly orbColor: string
  readonly iconBgClass: string
  readonly iconColorClass: string
}

export const APP_CARD_THEMES: Record<Exclude<PlatformApp, 'shell'>, AppCardTheme> = {
  pac: {
    accentHex: '#0d9488',
    glowColor: '0 8px 32px -4px rgba(13, 148, 136, 0.35)',
    orbColor: 'rgba(13, 148, 136, 0.15)',
    iconBgClass: 'bg-teal-500/10',
    iconColorClass: 'text-teal-500',
  },
  discovery: {
    accentHex: '#7c3aed',
    glowColor: '0 8px 32px -4px rgba(124, 58, 237, 0.35)',
    orbColor: 'rgba(124, 58, 237, 0.15)',
    iconBgClass: 'bg-violet-500/10',
    iconColorClass: 'text-violet-500',
  },
  identity: {
    accentHex: '#d97706',
    glowColor: '0 8px 32px -4px rgba(217, 119, 6, 0.35)',
    orbColor: 'rgba(217, 119, 6, 0.15)',
    iconBgClass: 'bg-amber-500/10',
    iconColorClass: 'text-amber-500',
  },
  'polix-ai': {
    accentHex: '#4f46e5',
    glowColor: '0 8px 32px -4px rgba(79, 70, 229, 0.35)',
    orbColor: 'rgba(79, 70, 229, 0.15)',
    iconBgClass: 'bg-indigo-500/10',
    iconColorClass: 'text-indigo-500',
  },
  analytics: {
    accentHex: '#0ea5e9',
    glowColor: '0 8px 32px -4px rgba(14, 165, 233, 0.35)',
    orbColor: 'rgba(14, 165, 233, 0.15)',
    iconBgClass: 'bg-sky-500/10',
    iconColorClass: 'text-sky-500',
  },
  docs: {
    accentHex: '#e11d48',
    glowColor: '0 8px 32px -4px rgba(225, 29, 72, 0.35)',
    orbColor: 'rgba(225, 29, 72, 0.15)',
    iconBgClass: 'bg-rose-500/10',
    iconColorClass: 'text-rose-500',
  },
}
